import React from "react";
import { makeStyles, Grid } from "@material-ui/core";
import ChooseCard from "../components/ChooseCard";
import Book from "../components/Book";
import Hat from "../components/Hat";

const useStyles = makeStyles({
  section: {
    margin: "4vw 0px",
    textAlign: "center",
    padding: "64px 10vw",
    position: "relative"
  }
});

export default function Choose() {
  const classes = useStyles();

  return (
    <section>
      <section className={classes.section}>
        <br /> <br /> <br />
        <Grid container spacing={4} justify="center">
          <Grid item xs={12} md={6}>
            <ChooseCard
              title="جواب سوال‌های شما اینجاست"
              button="دیدن سوالات متداول"
              icon={<Book />}
              color="blue"
              btnId="q-show-faq"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <ChooseCard
              title="برای یادگیری اینجا هستید؟‬"
              button="شروع یادگیری‬"
              icon={<Hat />}
              color="cyan"
              btnId="q-start-learning"
            />
          </Grid>
        </Grid>
      </section>
    </section>
  );
}
